import { Component, Input } from '@angular/core';

@Component({
    selector: 'ecm-layout-container',
    templateUrl: './layout-container.component.html',
})
export class LayoutContainerComponent {
    @Input() public lateralMenu = false;
    @Input() public carrousel = false;
    @Input() public isXlScreen = false;
}
